export default {
  path: "manager",
  component: () =>
    import(/* webpackChunkName: "manager-list" */ "@/pages/common/Empty"),
  children: [
    {
      path: "createAccountRecord",
      component: () =>
        import(
          /* webpackChunkName: "manager-account" */ "@/pages/hrManager/createAccountRecord"
        ),
      meta: { title: "企业开户审核" },
    },
    {
      name: 'createAccountRecordEdit',
      path: 'createAccountRecord/:company_id/edit',
      component: () => import('@/pages/company/CreateEdit'),
      meta: {
        title: '编辑企业开户审核'
      },
    },
    {
      path: "insuranceManage",
      component: () =>
        import(
          /* webpackChunkName: "manager-insurance" */ "@/pages/hrManager/insuranceManage/insuranceManage"
        ),
      meta: { title: "保险管理" },
    },
    {
      path: "insuranceReview",
      component: () =>
        import(
          /* webpackChunkName: "manager-insurance-review" */ "@/pages/hrManager/insuranceManage/insuranceReview"
        ),
      meta: { title: "保险审核" },
    },
    {
      path: "insuranceDetail",
      component: () =>
        import(
          /* webpackChunkName: "manager-insurance-detail" */ "@/pages/hrManager/insuranceManage/insuranceDetail"
        ),
      meta: { title: "保险详情" },
    },
    {
      path: "information",
      component: () =>
        import(
          /* webpackChunkName: "manager-information" */ "@/pages/hrManager/information/information"
        ),
      meta: { title: "资讯管理" },
    },
    {
      path: "announce",
      component: () =>
        import(
          /* webpackChunkName: "manager-announce" */ "@/pages/hrManager/announce/announce"
        ),
      meta: { title: "公告管理" },
    },
    {
      path: "courseRelease",
      component: () =>
        import(
          /* webpackChunkName: "manager-course-release" */ "@/pages/hrManager/courseManage/courseRelease/courseRelease"
        ),
      meta: { title: "课程发布" },
    },
    {
      path: "courseCreate",
      component: () =>
        import(
          /* webpackChunkName: "manager-course-create" */ "@/pages/hrManager/courseManage/courseRelease/createCourse"
        ),
      meta: { title: "课程编辑" },
    },
    {
      path: "courseReview",
      component: () =>
        import(
          /* webpackChunkName: "manager-course-review" */ "@/pages/hrManager/courseManage/courseReview/courseReview"
        ),
      meta: { title: "课程审核" },
    },
    {
      path: "registrationRecord",
      component: () =>
        import(
          /* webpackChunkName: "manager-registration-record" */ "@/pages/hrManager/courseManage/registrationRecord/registrationRecord"
        ),
      meta: { title: "报名记录" },
    },
    {
      path: "registrationDetails",
      component: () =>
        import(
          /* webpackChunkName: "manager-registration-details" */ "@/pages/hrManager/courseManage/registrationRecord/registrationDetails"
        ),
      meta: { title: "报名详情" },
    },
    {
      path: "jobList",
      component: () =>
        import(
          /* webpackChunkName: "manager-job-list" */ "@/pages/hrManager/jobManage/JobList"
        ),
      meta: { title: "岗位管理" },
    },
    {
      path: "jobDetails",
      component: () =>
        import(
          /* webpackChunkName: "manager-job-details" */ "@/pages/hrManager/jobManage/details"
        ),
      meta: { title: "岗位详情" },
    },
  ],
};
